import { Button } from '@material-ui/core';
import { ErrorAPI } from 'api/Associado/methods';
import { AxiosError } from 'axios';
import { AssembleiaIcon, SyncIcon } from 'components/Icons';
import { AssembleiaPautaStatus } from 'enuns/AssembleiaPautaStatus';
import React, { ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { assembleiasAssessorActionsRegistraVoto } from 'store/modules/AssembleiasAssessorActions';
import { IReducer } from 'store/Reducer';
import ErrorHandler from 'utils/ErrorHandler';
import { getToastSuccess } from 'utils/ToasterUtils';
import { IPauta } from './AssembleiaPautas';
import useStyles from './style';

interface RouteParams {
  idAssembleia: string;
  cpfRepresentante: string;
}

export interface IAssembleiaPautaAssociadoActionButtons {
  loading: boolean,
  setLoading: Function,
  pauta: IPauta,
  voto: number,
}

export default ({
  loading,
  setLoading,
  pauta,
  voto
}: IAssembleiaPautaAssociadoActionButtons) => {
  const { usuario } = useSelector((state: IReducer) => state.auth);
  const { t } = useTranslation();
  const classes = useStyles();
  const [sending, setSending] = useState<boolean>(false);
  const dispatchAction = useDispatch();
  const currentEvent = useSelector((state: IReducer) => state.assembleiasAssessor.evento);
  const { cpfRepresentante } = useParams<RouteParams>();

  const registarVoto = useCallback(() => {
    setSending(true);
  }, [setSending])

  const showError = useCallback((error: AxiosError<ErrorAPI>) => {
    ErrorHandler(error.response!.data);
  }, [])

  const mostrarRegistrarVotoButton = useMemo(() => {
    return (
      pauta.status === AssembleiaPautaStatus.Liberada &&
      voto > -1
    )
  }, [pauta, voto])

  const registrarVotoButton = useMemo(() => {
    return mostrarRegistrarVotoButton  && (
      <Button
        key={1}
        className={ classes.botaoAcoes }
        variant="contained"
        color="primary"
        disabled={sending}
        onClick={ registarVoto }
        startIcon={ <AssembleiaIcon /> }
        endIcon={ sending ? <SyncIcon className="animation-rotate" /> : null }
      >
        { t('AssembleiaPauta.acoes.confirmar') }
      </Button>
    )
  }, [mostrarRegistrarVotoButton, classes, sending, registarVoto, t])


  const buttons = useMemo<ReactNode[]>(() => {
    return [
      registrarVotoButton,
    ]
  }, [ registrarVotoButton ])

  useEffect(() => {
    setLoading(sending)
  }, [sending, setLoading]);

  useEffect(() => {
    if (sending && !loading && currentEvent) {
      dispatchAction(assembleiasAssessorActionsRegistraVoto(
        voto,
        atob(cpfRepresentante),
        () => {
          getToastSuccess(t('AssembleiaPauta.acoes.confirmado'))
          setSending(false);
        },
        error => {
          setSending(false);
          showError(error);
        }
      ))
    }
  }, [usuario, t, voto, sending, currentEvent, loading, dispatchAction, showError, cpfRepresentante]);

  return buttons.filter(it => it !== null) ? (
    <div>
      {buttons.map(it => it)}
    </div>
  ) : null;
}